<script setup lang="ts">
const router = useRouter();
const route = useRoute();

type ListingFilter = {
  code: string;
  label: string;
};

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters?: any;
}>();

const rating = computed({
  get: () =>
    props.selectedFilters?.rating
      ? Number(props.selectedFilters?.rating)
      : undefined,
  set: (newValue: number | undefined) => {
    router.push({ query: { ...route.query, p: 1, rating: newValue } });
    return newValue;
  },
});
</script>

<template>
  <div class="flex gap-3">
    <Rating v-model="rating" />

    <SharedTransition>
      <div v-if="rating" class="flex justify-between items-center flex-1">
        <span class="text-sm text-gray-500">
          {{ rating }} {{ $t("listing.ratingStars") }}
        </span>

        <Button
          icon="true"
          icon-class="pi pi-times"
          class="!p-1 w-min h-5 text-sm"
          text
          @click="rating = undefined"
        />
      </div>
    </SharedTransition>
  </div>
</template>
